module.exports = {
  WBI: "WBI",
  WBS: "WBS",
  WBU: "WBU",
  WBR: "WBR",
  WBC: "WBC",
  WBT: "WBT",
  ONL: "ONL",
  UVC: "UVC",
  GDS: "GDS",
};
